export const invoiceKeyNames = [
  "firstName",
  "lastName",
  "companyName",
  "vat",
  "fiscalCode",
  "sdi",
  "billingCountry",
  "billingAddress",
  "billingCity",
  "billingProvince",
  "billingZipCode"
];

/** Keys shown only for Privato (intestatario persona fisica). */
export const invoicePersonOnlyKeys = ["firstName", "lastName"];

/** Keys shown only for Azienda. */
export const invoiceCompanyOnlyKeys = ["companyName", "vat"];
